import { HStack, Stack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import ProceedCancelButtons from "components/Button/ProceedCancelButtons";
import { FloatingField } from "design-system";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Template, TemplateSummary } from "../models";
import { useDuplicateTemplate } from "../hooks";
import { extractTemplate } from "../helpers";

const NAME_FIELD = {
  type: "text",
  label: "Template Name",
  name: "name",
};

const schema = yup.object({
  name: yup.string().label(NAME_FIELD.label).required(),
});

type Schema = yup.InferType<typeof schema>;

export default function DuplicateTemplateForm({
  template,
  onClose,
}: {
  template: TemplateSummary | Template;
  onClose: () => void;
}) {
  const resolvedTemplate = extractTemplate(template);
  const { mutate: handleDuplicate, isPending } = useDuplicateTemplate(template, onClose);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm<Schema>({
    mode: "onBlur",
    resolver: yupResolver(schema),
    defaultValues: { name: `${resolvedTemplate?.name} (Copy)` },
  });
  return (
    <Stack spacing="3">
      <HStack spacing="5">
        <FloatingField name="name" errors={errors.name?.message} required>
          <FloatingField.Label>Template Name</FloatingField.Label>
          <FloatingField.Text control={control} name="name" />
        </FloatingField>
      </HStack>
      <HStack mt={12} justify="end">
        <ProceedCancelButtons
          handleSubmit={handleSubmit(handleDuplicate)}
          onClose={onClose}
          proceedText="Duplicate"
          isLoading={isPending}
        />
      </HStack>
    </Stack>
  );
}
